import { TRANSFER_ADD } from '../../utils/permissions'

export default [
  // transfer list
  {
    path: '/transfer/list',
    name: 'transfer-list',
    component: () => import('@/views/transfers/TransferList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Transfer List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Transfer' }, { title: 'Transfer List', active: true }],
      permissions: [TRANSFER_ADD]
    }
  },

  // transfer details
  {
    path: '/transfer/details',
    name: 'transfer-details',
    component: () => import('@/views/transfers/AddTransferDetails.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Transfer Details',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Transfer', url: '/transfer/details' },
        { title: 'Transfer Details', active: true }
      ],
      permissions: [TRANSFER_ADD]
    }
  }
]
